"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANY_VALUE = exports.priceOptions = void 0;
exports.priceOptions = [
    { caption: '50 CHF', value: 50 },
    { caption: '200 CHF', value: 200 },
    { caption: '400 CHF', value: 400 },
    { caption: '600 CHF', value: 600 },
    { caption: '800 CHF', value: 800 },
    { caption: '1000 CHF', value: 1000 },
    { caption: '1500 CHF', value: 1500 },
    { caption: '2000 CHF', value: 2000 },
    { caption: '2500 CHF', value: 2500 },
    { caption: `Any`, value: null },
];
exports.ANY_VALUE = 'Any';
//# sourceMappingURL=PriceRange.common.js.map